import { CssModifiers, DomHelpers } from '../../utils'

const _$ = window.$

let _$sourceField = null
let _$destinationField = null
let _desiredValuesArray = undefined

const _hasValue = value => typeof value != undefined && Boolean(value.length)

const init = () => {
  if (!_$) return
  addCustomValidationMethods()
  _$(addEventListeners)
}

const addCustomValidationMethods = async () => {
  _$.validator.addMethod('requiredif',
    value => {
      // jQuery Validator methods should return truthy (is valid if...)
      return (_desiredValuesArray.includes(_$sourceField.value) && _hasValue(value) == false) == false
    })

  _$.validator.unobtrusive.adapters.add('requiredif', ['propertyname', 'desiredvalues'],
    options => {

      const { desiredvalues, propertyname } = options.params

      _$sourceField = document.querySelector(`#Form_${propertyname}`)
      if (_$sourceField == null) return
      _desiredValuesArray = desiredvalues.split('|')
      _$destinationField = options.element

      options.rules.requiredif = {
        propertyname: options.params.propertyname,
        desiredvalues: options.params.desiredvalues
      }

      options.messages.requiredif = options.message
    })
}

const toggleDestinationField = () => {
  const isDesiredValue = _desiredValuesArray.includes(_$sourceField.value)
  // Negating the condition here so as to remove the modifier when a match is found
  CssModifiers.toggle(_$destinationField.parentNode, isDesiredValue == false, 'm-is-hidden')
}

const addEventListeners = () => {
  if (_$sourceField == null) return
  _$sourceField.addEventListener('change', toggleDestinationField)
}

const RequiredIf = { init }
export default RequiredIf




// WEBPACK FOOTER //
// ./js/core/validation/RequiredIf.js